export const currencyOpt = [
  { code: "USD", country: "United States", label: "United States – USD ($)" },
  { code: "EUR", country: "European Union", label: "European Union – EUR (€)" },
  { code: "GBP", country: "United Kingdom", label: "United Kingdom – GBP (£)" },
  { code: "PKR", country: "Pakistan", label: "Pakistan – PKR (Rs)" },
  { code: "SAR", country: "Saudi Arabia", label: "Saudi Arabia – SAR (﷼)" },
  { code: "AED", country: "United Arab Emirates", label: "UAE – AED (د.إ)" },
  { code: "INR", country: "India", label: "India – INR (₹)" },
  { code: "CNY", country: "China", label: "China – CNY (¥)" },
  { code: "JPY", country: "Japan", label: "Japan – JPY (¥)" },
  { code: "CAD", country: "Canada", label: "Canada – CAD ($)" },
  { code: "AUD", country: "Australia", label: "Australia – AUD ($)" },
  { code: "CHF", country: "Switzerland", label: "Switzerland – CHF (Fr)" },
  { code: "SEK", country: "Sweden", label: "Sweden – SEK (kr)" },
  { code: "NOK", country: "Norway", label: "Norway – NOK (kr)" },
  { code: "NZD", country: "New Zealand", label: "New Zealand – NZD ($)" },
  { code: "ZAR", country: "South Africa", label: "South Africa – ZAR (R)" },
  { code: "SGD", country: "Singapore", label: "Singapore – SGD ($)" },
  { code: "HKD", country: "Hong Kong", label: "Hong Kong – HKD ($)" },
  { code: "TRY", country: "Turkey", label: "Turkey – TRY (₺)" },
  { code: "THB", country: "Thailand", label: "Thailand – THB (฿)" },
];
